import styled from "@emotion/styled";
import { Box, Button, } from "@mui/material"
import { useLocation, useNavigate } from "react-router-dom";
import { FC } from "react";
import React from "react";
import { signOut } from "aws-amplify/auth";
import logoutBackend from "shared/logoutBackend";
import {setSessionItem, HEADER_DISABLED_KEY} from "../storageCheck/storageCheck";

const HeaderLabel = styled.header`
    background-color: #41DBCE;
    color: #FFFFFF;
    height: 3rem;
    font-size: 1.5rem;
    padding-top: 0.5rem;
    padding-left: 4rem;
`;

const ReturnButton = styled(Button)(({ }) => ({
    backgroundColor: '#F2F2F2',
    color: '#595959',
    textAlign: 'left',
    fontSize: '1.2rem',
    height: '3.2rem',
    width: '17rem',
    borderRadius: '100rem',
}));


const Error: FC = () => {
    const location = useLocation();
    const { title, message } = location.state
    const logoutAction = async () => {
        // ログアウト(サーバーサイド)
        await logoutBackend();
        // サインアウト(Authenticator)
        signOut();
        // セッションストレージのクリア
        sessionStorage.clear();
        document.title = "TSR中小企業経営指標";
        window.history.replaceState("", "", "/Top");
    }

    React.useEffect(() => {
        // ブラウザのタブに表示される値の更新
        document.title = title;

        setSessionItem(HEADER_DISABLED_KEY, "true")
        return () => setSessionItem(HEADER_DISABLED_KEY, "false")
    }, []);


    return (
        <>
            <HeaderLabel>
                {title}
            </HeaderLabel>
            <Box sx={{ textAlign: 'center', marginTop:"12rem", marginBottom: "15rem" }}>
                <div>
                    {message}
                </div>
                <ReturnButton variant="contained" color="secondary" style={{ marginTop: '25px' }} onClick={() => logoutAction()}><img src={`${process.env.PUBLIC_URL}/Icons/returnIcon.svg`} width="13px" />&nbsp;ログイン画面に戻る</ReturnButton>
            </Box>
        </>
    );
}
export default Error;
